import { getLocation } from "@Pages/PropertyPage/data/helper";
import getFeaturedImage from "./getFeaturedImage";
import getImagePath from "./getImagePath";

const getApartmentSchema = (inventoryData: any = {}, inventoryUrl = "") => {
  const data: any = {
    "@context": "https://schema.org",
    "@type": "Apartment",
    name: inventoryData?.name,
    url: inventoryUrl,
  };

  // image
  const featuredImage = inventoryData?.images?.length
    ? getFeaturedImage(inventoryData?.images)
    : {};
  const imagePath = getImagePath(featuredImage?.path, "hero");

  if (imagePath) {
    data.image = imagePath;
  }

  // telephone
  if (inventoryData?.owner?.phones[0]) {
    // eslint-disable-next-line prefer-destructuring
    data.telephone = inventoryData.owner.phones[0];
  }

  // geo
  if (inventoryData?.location_coordinates?.lat && inventoryData?.location_coordinates?.lng) {
    data.geo = {
      "@type": "GeoCoordinates",
      latitude: inventoryData.location_coordinates.lat,
      longitude: inventoryData.location_coordinates.lng,
    };
  }

  // address
  data.address = {
    "@type": "PostalAddress",
  };
  const locationStreetAddress = getLocation(inventoryData?.location, [
    "street_number",
    "route_long_name",
  ]);
  const locationLocality = getLocation(inventoryData?.location, ["locality_long_name"]);
  const locationState = getLocation(inventoryData?.location, ["state_long_name"]);
  const locationCountry = getLocation(inventoryData?.location, ["country_short_name"]);
  const locationPostalCode = getLocation(inventoryData?.location, ["postal_code"]);
  if (locationStreetAddress) data.address.streetAddress = locationStreetAddress;
  if (locationLocality) data.address.addressLocality = locationLocality;
  if (locationState) data.address.addressRegion = locationState;
  if (locationCountry) data.address.addressCountry = locationCountry;
  if (locationPostalCode) data.address.postalCode = locationPostalCode;

  // amenity features
  if (inventoryData?.features?.length > 0 && inventoryData?.features[0]?.values?.length > 0) {
    const amenityFeatures: any = [];

    inventoryData.features.forEach((feature: any) => {
      feature.values.forEach((value: any) => {
        amenityFeatures.push({
          "@type": "LocationFeatureSpecification",
          name: value?.name,
          value: true,
        });
      });
    });

    data.amenityFeature = amenityFeatures;
  }

  return data;
};

const generateApartmentSchemaData = (inventoryData = {}, inventoryUrl = "") => {
  const apartmentSchemaData = getApartmentSchema(inventoryData, inventoryUrl);
  return [apartmentSchemaData];
};

export default generateApartmentSchemaData;
